// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"footer_wrapper__2dIrM"};